import type { EventData } from '@/store/models/events/entities';
import type { EventId, BuildingId, SpaceId, RequestId } from '@/store/models/ids';

export const MOCK_EVENT_DETAILS: Record<string, EventData> = {
  'evt-p001': {
    eventId: 'evt-p001' as EventId,
    requestId: 'REF-1234' as RequestId,
    eventTitle: 'Global Connect',
    eventState: 'UNDER_REVIEW',
    buildingId: 'bld-001' as BuildingId,
    buildingName: 'Building 21',
    plannerAssignedEmail: 'testplanner@contoso.com',
    eventStartDate: '2028-04-22T09:00:00Z',
    eventEndDate: '2028-04-22T17:00:00Z',
    numberOfAttendees: 150,
    spaceId: 'sp-001' as SpaceId,
    spaceName: 'Large Conference Room 450',
    spaces: [
      {
        spaceId: 'sp-001' as SpaceId,
        spaceName: 'Large Conference Room 450',
        selectedSetupCodes: ['THEATER'],
      },
    ],
    visitPurposeCode: 'Team Meeting',
    attendeeTypeCode: 'MS FTE and External',
    sponsor: { name: 'Jamie Smith', email: 'jsmith@microsoft.com', costCenter: 'IO-12345' },
    onSiteContacts: [
      { name: 'Jamie Smith', email: 'jsmith@microsoft.com' },
      { name: 'Sam Wilson', email: 'swilson@microsoft.com' },
    ],
    hasCatering: true,
    filmingRequired: false,
    overnightStorageRequired: false,
    shipmentsExpected: true,
    additionalInformation: 'Need AV setup for main presentation',
    submittedBy: 'Marketing Team',
    submittedDate: '2026-03-15T10:00:00Z',
    createdBy: 'mteam@microsoft.com',
    createdAt: '2026-03-15T10:00:00Z',
    lastUpdatedAt: '2026-04-20T14:30:00Z',
    lastUpdatedBy: 'planner@microsoft.com',
    stateHistory: [
      {
        fromState: 'DRAFT',
        toState: 'SUBMITTED',
        changedBy: 'mteam@microsoft.com',
        changedAt: '2026-03-15T10:00:00Z',
      },
      {
        fromState: 'SUBMITTED',
        toState: 'UNDER_REVIEW',
        changedBy: 'sarah.chen@microsoft.com',
        changedAt: '2026-04-20T14:30:00Z',
      },
    ],
  },
  'evt-p002': {
    eventId: 'evt-p002' as EventId,
    requestId: 'REF-1235' as RequestId,
    eventTitle: 'Product Innovation Summit',
    eventState: 'SUBMITTED',
    buildingId: 'bld-002' as BuildingId,
    buildingName: 'Building 20',
    eventStartDate: '2028-05-10T10:00:00Z',
    eventEndDate: '2028-05-10T18:00:00Z',
    numberOfAttendees: 200,
    spaceId: 'sp-002' as SpaceId,
    spaceName: 'Innovation Lab',
    spaces: [
      {
        spaceId: 'sp-002' as SpaceId,
        spaceName: 'Innovation Lab',
        selectedSetupCodes: ['CLASSROOM'],
      },
    ],
    visitPurposeCode: 'Product Launch',
    attendeeTypeCode: 'MS FTE Only',
    sponsor: { name: 'Jordan Lee', email: 'jlee@microsoft.com', costCenter: 'IO-67890' },
    onSiteContacts: [{ name: 'Jordan Lee', email: 'jlee@microsoft.com' }],
    hasCatering: true,
    filmingRequired: true,
    overnightStorageRequired: true,
    shipmentsExpected: false,
    submittedBy: 'Product Development',
    submittedDate: '2026-02-20T08:00:00Z',
    createdBy: 'pdev@microsoft.com',
    createdAt: '2026-02-20T08:00:00Z',
    lastUpdatedAt: '2026-02-20T08:00:00Z',
    stateHistory: [
      {
        fromState: 'DRAFT',
        toState: 'SUBMITTED',
        changedBy: 'pdev@microsoft.com',
        changedAt: '2026-02-20T08:00:00Z',
      },
    ],
  },
  'evt-p003': {
    eventId: 'evt-p003' as EventId,
    requestId: 'REF-1236' as RequestId,
    eventTitle: 'Annual Sales Conference',
    eventState: 'CONFIRMED',
    buildingId: 'bld-001' as BuildingId,
    buildingName: 'Building 21',
    eventStartDate: '2028-06-01T08:00:00Z',
    eventEndDate: '2028-06-01T16:00:00Z',
    numberOfAttendees: 300,
    spaceId: 'sp-003' as SpaceId,
    spaceName: 'Grand Ballroom',
    spaces: [
      {
        spaceId: 'sp-003' as SpaceId,
        spaceName: 'Grand Ballroom',
        selectedSetupCodes: ['THEATER'],
      },
    ],
    visitPurposeCode: 'Sales Kickoff',
    attendeeTypeCode: 'MS FTE and External',
    sponsor: { name: 'Casey White', email: 'cwhite@microsoft.com', costCenter: 'IO-11111' },
    onSiteContacts: [{ name: 'Casey White', email: 'cwhite@microsoft.com' }],
    hasCatering: true,
    filmingRequired: false,
    overnightStorageRequired: false,
    shipmentsExpected: true,
    submittedBy: 'Sales Department',
    submittedDate: '2026-01-10T12:00:00Z',
    createdBy: 'sales@microsoft.com',
    createdAt: '2026-01-10T12:00:00Z',
    lastUpdatedAt: '2026-04-01T09:00:00Z',
    lastUpdatedBy: 'planner@microsoft.com',
    stateHistory: [
      {
        fromState: 'DRAFT',
        toState: 'SUBMITTED',
        changedBy: 'sales@microsoft.com',
        changedAt: '2026-01-10T12:00:00Z',
      },
      {
        fromState: 'SUBMITTED',
        toState: 'UNDER_REVIEW',
        changedBy: 'sarah.chen@microsoft.com',
        changedAt: '2026-03-15T10:00:00Z',
      },
      {
        fromState: 'UNDER_REVIEW',
        toState: 'CONFIRMED',
        changedBy: 'sarah.chen@microsoft.com',
        changedAt: '2026-04-01T09:00:00Z',
      },
    ],
  },
  'evt-p004': {
    eventId: 'evt-p004' as EventId,
    requestId: 'REF-1237' as RequestId,
    eventTitle: 'Customer Success Workshop',
    eventState: 'SUBMITTED',
    buildingId: 'bld-002' as BuildingId,
    buildingName: 'Building 20',
    eventStartDate: '2028-07-15T11:00:00Z',
    eventEndDate: '2028-07-15T19:00:00Z',
    numberOfAttendees: 80,
    spaceId: 'sp-002' as SpaceId,
    spaceName: 'Innovation Lab',
    spaces: [
      {
        spaceId: 'sp-002' as SpaceId,
        spaceName: 'Innovation Lab',
        selectedSetupCodes: ['CLASSROOM'],
      },
    ],
    visitPurposeCode: 'Team Meeting',
    attendeeTypeCode: 'MS FTE and External',
    sponsor: { name: 'Riley Green', email: 'rgreen@microsoft.com', costCenter: 'CC-55555' },
    onSiteContacts: [{ name: 'Riley Green', email: 'rgreen@microsoft.com' }],
    hasCatering: false,
    filmingRequired: false,
    overnightStorageRequired: false,
    shipmentsExpected: false,
    submittedBy: 'Customer Relations',
    submittedDate: '2025-12-01T09:00:00Z',
    createdBy: 'custrel@microsoft.com',
    createdAt: '2025-12-01T09:00:00Z',
    lastUpdatedAt: '2025-12-01T09:00:00Z',
    stateHistory: [
      {
        fromState: 'DRAFT',
        toState: 'SUBMITTED',
        changedBy: 'custrel@microsoft.com',
        changedAt: '2025-12-01T09:00:00Z',
      },
    ],
  },
  'evt-p005': {
    eventId: 'evt-p005' as EventId,
    requestId: 'REF-1238' as RequestId,
    eventTitle: 'AI Developers Conference',
    eventState: 'CANCELLED',
    buildingId: 'bld-002' as BuildingId,
    buildingName: 'Building 20',
    eventStartDate: '2026-08-01T09:30:00Z',
    eventEndDate: '2026-08-01T17:30:00Z',
    numberOfAttendees: 250,
    spaceId: 'sp-003' as SpaceId,
    spaceName: 'Grand Ballroom',
    spaces: [
      {
        spaceId: 'sp-003' as SpaceId,
        spaceName: 'Grand Ballroom',
        selectedSetupCodes: ['THEATER'],
      },
    ],
    visitPurposeCode: 'Product Launch',
    attendeeTypeCode: 'MS FTE Only',
    sponsor: { name: 'Taylor Grey', email: 'tgrey@microsoft.com', costCenter: 'CC-66666' },
    onSiteContacts: [{ name: 'Taylor Grey', email: 'tgrey@microsoft.com' }],
    hasCatering: true,
    filmingRequired: true,
    overnightStorageRequired: false,
    shipmentsExpected: true,
    submittedBy: 'Engineering Division',
    submittedDate: '2025-11-05T10:00:00Z',
    createdBy: 'engdiv@microsoft.com',
    createdAt: '2025-11-05T10:00:00Z',
    lastUpdatedAt: '2026-01-10T14:00:00Z',
    stateHistory: [
      {
        fromState: 'DRAFT',
        toState: 'SUBMITTED',
        changedBy: 'engdiv@microsoft.com',
        changedAt: '2025-11-05T10:00:00Z',
      },
      {
        fromState: 'SUBMITTED',
        toState: 'CANCELLED',
        changedBy: 'tgrey@microsoft.com',
        changedAt: '2026-01-10T14:00:00Z',
      },
    ],
  },
  'evt-p006': {
    eventId: 'evt-p006' as EventId,
    requestId: 'REF-1239' as RequestId,
    eventTitle: 'Cloud Solutions Expo',
    eventState: 'UNDER_REVIEW',
    buildingId: 'bld-002' as BuildingId,
    buildingName: 'Building 20',
    plannerAssignedEmail: 'testplanner@contoso.com',
    eventStartDate: '2026-09-20T14:00:00Z',
    eventEndDate: '2026-09-20T22:00:00Z',
    numberOfAttendees: 120,
    spaceId: 'sp-001' as SpaceId,
    spaceName: 'Large Conference Room 450',
    spaces: [
      {
        spaceId: 'sp-001' as SpaceId,
        spaceName: 'Large Conference Room 450',
        selectedSetupCodes: ['THEATER'],
      },
    ],
    visitPurposeCode: 'Non-Profit',
    attendeeTypeCode: 'MS FTE and External',
    sponsor: { name: 'Morgan Blue', email: 'mblue@microsoft.com', costCenter: 'CC-77777' },
    onSiteContacts: [{ name: 'Morgan Blue', email: 'mblue@microsoft.com' }],
    hasCatering: true,
    filmingRequired: false,
    overnightStorageRequired: true,
    shipmentsExpected: false,
    submittedBy: 'IT Solutions Group',
    submittedDate: '2025-10-25T08:00:00Z',
    createdBy: 'itgroup@microsoft.com',
    createdAt: '2025-10-25T08:00:00Z',
    lastUpdatedAt: '2025-11-10T09:00:00Z',
    stateHistory: [
      {
        fromState: 'DRAFT',
        toState: 'SUBMITTED',
        changedBy: 'itgroup@microsoft.com',
        changedAt: '2025-10-25T08:00:00Z',
      },
      {
        fromState: 'SUBMITTED',
        toState: 'UNDER_REVIEW',
        changedBy: 'sarah.chen@microsoft.com',
        changedAt: '2025-11-10T09:00:00Z',
      },
    ],
  },
  'evt-p007': {
    eventId: 'evt-p007' as EventId,
    requestId: 'REF-1240' as RequestId,
    eventTitle: 'Digital Marketing Forum',
    eventState: 'UNDER_REVIEW',
    buildingId: 'bld-002' as BuildingId,
    buildingName: 'Building 20',
    plannerAssignedEmail: 'testplanner@contoso.com',
    eventStartDate: '2026-09-20T14:00:00Z',
    eventEndDate: '2026-09-20T22:00:00Z',
    numberOfAttendees: 60,
    spaceId: 'sp-004' as SpaceId,
    spaceName: 'Meeting Room 210',
    spaces: [
      {
        spaceId: 'sp-004' as SpaceId,
        spaceName: 'Meeting Room 210',
        selectedSetupCodes: ['BOARDROOM'],
      },
    ],
    visitPurposeCode: 'Team Meeting',
    attendeeTypeCode: 'MS FTE Only',
    sponsor: { name: 'Morgan Blue', email: 'mblue@microsoft.com', costCenter: 'CC-77777' },
    onSiteContacts: [{ name: 'Morgan Blue', email: 'mblue@microsoft.com' }],
    hasCatering: false,
    filmingRequired: false,
    overnightStorageRequired: false,
    shipmentsExpected: false,
    submittedBy: 'Research and Development',
    submittedDate: '2025-08-15T09:00:00Z',
    createdBy: 'rnd@microsoft.com',
    createdAt: '2025-08-15T09:00:00Z',
    lastUpdatedAt: '2025-09-01T10:00:00Z',
    stateHistory: [
      {
        fromState: 'DRAFT',
        toState: 'SUBMITTED',
        changedBy: 'rnd@microsoft.com',
        changedAt: '2025-08-15T09:00:00Z',
      },
      {
        fromState: 'SUBMITTED',
        toState: 'UNDER_REVIEW',
        changedBy: 'sarah.chen@microsoft.com',
        changedAt: '2025-09-01T10:00:00Z',
      },
    ],
  },
  'evt-p008': {
    eventId: 'evt-p008' as EventId,
    requestId: 'REF-1241' as RequestId,
    eventTitle: 'UX Design Symposium',
    eventState: 'SUBMITTED',
    buildingId: 'bld-002' as BuildingId,
    buildingName: 'Building 20',
    eventStartDate: '2026-09-20T14:00:00Z',
    eventEndDate: '2026-09-20T22:00:00Z',
    numberOfAttendees: 40,
    spaceId: 'sp-005' as SpaceId,
    spaceName: 'Board Room',
    spaces: [
      {
        spaceId: 'sp-005' as SpaceId,
        spaceName: 'Board Room',
        selectedSetupCodes: ['BOARDROOM'],
      },
    ],
    visitPurposeCode: 'Team Meeting',
    attendeeTypeCode: 'MS FTE and External',
    sponsor: { name: 'Morgan Blue', email: 'mblue@microsoft.com', costCenter: 'CC-77777' },
    onSiteContacts: [{ name: 'Morgan Blue', email: 'mblue@microsoft.com' }],
    hasCatering: true,
    filmingRequired: false,
    overnightStorageRequired: false,
    shipmentsExpected: true,
    submittedBy: 'Finance Department',
    submittedDate: '2025-07-10T09:00:00Z',
    createdBy: 'finance@microsoft.com',
    createdAt: '2025-07-10T09:00:00Z',
    lastUpdatedAt: '2025-07-10T09:00:00Z',
    stateHistory: [
      {
        fromState: 'DRAFT',
        toState: 'SUBMITTED',
        changedBy: 'finance@microsoft.com',
        changedAt: '2025-07-10T09:00:00Z',
      },
    ],
  },
  'evt-p009': {
    eventId: 'evt-p009' as EventId,
    requestId: 'REF-1242' as RequestId,
    eventTitle: 'Blockchain Meetup',
    eventState: 'SUBMITTED',
    buildingId: 'bld-002' as BuildingId,
    buildingName: 'Building 20',
    eventStartDate: '2026-09-20T14:00:00Z',
    eventEndDate: '2026-09-20T22:00:00Z',
    numberOfAttendees: 35,
    spaceId: 'sp-004' as SpaceId,
    spaceName: 'Meeting Room 210',
    spaces: [
      {
        spaceId: 'sp-004' as SpaceId,
        spaceName: 'Meeting Room 210',
        selectedSetupCodes: ['CLASSROOM'],
      },
    ],
    visitPurposeCode: 'Non-Profit',
    attendeeTypeCode: 'MS FTE Only',
    sponsor: { name: 'Morgan Blue', email: 'mblue@microsoft.com', costCenter: 'CC-77777' },
    onSiteContacts: [{ name: 'Morgan Blue', email: 'mblue@microsoft.com' }],
    hasCatering: false,
    filmingRequired: false,
    overnightStorageRequired: false,
    shipmentsExpected: false,
    submittedBy: 'Legal Affairs',
    submittedDate: '2025-06-01T09:00:00Z',
    createdBy: 'legal@microsoft.com',
    createdAt: '2025-06-01T09:00:00Z',
    lastUpdatedAt: '2025-06-01T09:00:00Z',
    stateHistory: [
      {
        fromState: 'DRAFT',
        toState: 'SUBMITTED',
        changedBy: 'legal@microsoft.com',
        changedAt: '2025-06-01T09:00:00Z',
      },
    ],
  },
  'evt-p010': {
    eventId: 'evt-p010' as EventId,
    requestId: 'REF-1243' as RequestId,
    eventTitle: 'Sustainability Summit',
    eventState: 'SUBMITTED',
    buildingId: 'bld-002' as BuildingId,
    buildingName: 'Building 20',
    eventStartDate: '2026-09-20T14:00:00Z',
    eventEndDate: '2026-09-20T22:00:00Z',
    numberOfAttendees: 100,
    spaceId: 'sp-001' as SpaceId,
    spaceName: 'Large Conference Room 450',
    spaces: [
      {
        spaceId: 'sp-001' as SpaceId,
        spaceName: 'Large Conference Room 450',
        selectedSetupCodes: ['THEATER'],
      },
    ],
    visitPurposeCode: 'Non-Profit',
    attendeeTypeCode: 'MS FTE and External',
    sponsor: { name: 'Morgan Blue', email: 'mblue@microsoft.com', costCenter: 'CC-77777' },
    onSiteContacts: [{ name: 'Morgan Blue', email: 'mblue@microsoft.com' }],
    hasCatering: true,
    filmingRequired: false,
    overnightStorageRequired: false,
    shipmentsExpected: false,
    additionalInformation: 'Wheelchair assistance required for the duration of the event.',
    submittedBy: 'Human Resources',
    submittedDate: '2025-05-20T09:00:00Z',
    createdBy: 'hr@microsoft.com',
    createdAt: '2025-05-20T09:00:00Z',
    lastUpdatedAt: '2025-05-20T09:00:00Z',
    stateHistory: [
      {
        fromState: 'DRAFT',
        toState: 'SUBMITTED',
        changedBy: 'hr@microsoft.com',
        changedAt: '2025-05-20T09:00:00Z',
      },
    ],
  },
  'evt-p011': {
    eventId: 'evt-p011' as EventId,
    requestId: 'REF-1244' as RequestId,
    eventTitle: 'Remote Work Conference',
    eventState: 'CONFIRMED',
    buildingId: 'bld-002' as BuildingId,
    buildingName: 'Building 20',
    eventStartDate: '2026-09-20T14:00:00Z',
    eventEndDate: '2026-09-20T22:00:00Z',
    numberOfAttendees: 150,
    spaceId: 'sp-003' as SpaceId,
    spaceName: 'Grand Ballroom',
    spaces: [
      {
        spaceId: 'sp-003' as SpaceId,
        spaceName: 'Grand Ballroom',
        selectedSetupCodes: ['THEATER'],
      },
    ],
    visitPurposeCode: 'Sales Kickoff',
    attendeeTypeCode: 'MS FTE and External',
    sponsor: { name: 'Morgan Blue', email: 'mblue@microsoft.com', costCenter: 'CC-77777' },
    onSiteContacts: [{ name: 'Morgan Blue', email: 'mblue@microsoft.com' }],
    hasCatering: false,
    filmingRequired: true,
    overnightStorageRequired: false,
    shipmentsExpected: false,
    submittedBy: 'Executive Management',
    submittedDate: '2025-04-25T09:00:00Z',
    createdBy: 'exec@microsoft.com',
    createdAt: '2025-04-25T09:00:00Z',
    lastUpdatedAt: '2026-03-01T09:00:00Z',
    stateHistory: [
      {
        fromState: 'DRAFT',
        toState: 'SUBMITTED',
        changedBy: 'exec@microsoft.com',
        changedAt: '2025-04-25T09:00:00Z',
      },
      {
        fromState: 'SUBMITTED',
        toState: 'UNDER_REVIEW',
        changedBy: 'sarah.chen@microsoft.com',
        changedAt: '2025-05-10T10:00:00Z',
      },
      {
        fromState: 'UNDER_REVIEW',
        toState: 'CONFIRMED',
        changedBy: 'sarah.chen@microsoft.com',
        changedAt: '2026-03-01T09:00:00Z',
      },
    ],
  },
  'evt-p012': {
    eventId: 'evt-p012' as EventId,
    requestId: 'REF-1245' as RequestId,
    eventTitle: 'Fintech Innovation Day',
    eventState: 'CONFIRMED',
    buildingId: 'bld-002' as BuildingId,
    buildingName: 'Building 20',
    eventStartDate: '2026-09-20T14:00:00Z',
    eventEndDate: '2026-09-20T22:00:00Z',
    numberOfAttendees: 75,
    spaceId: 'sp-002' as SpaceId,
    spaceName: 'Innovation Lab',
    spaces: [
      {
        spaceId: 'sp-002' as SpaceId,
        spaceName: 'Innovation Lab',
        selectedSetupCodes: ['CLASSROOM'],
      },
    ],
    visitPurposeCode: 'Product Launch',
    attendeeTypeCode: 'MS FTE Only',
    sponsor: { name: 'Morgan Blue', email: 'mblue@microsoft.com', costCenter: 'CC-77777' },
    onSiteContacts: [{ name: 'Morgan Blue', email: 'mblue@microsoft.com' }],
    hasCatering: true,
    filmingRequired: false,
    overnightStorageRequired: true,
    shipmentsExpected: true,
    submittedBy: 'Executive Management',
    submittedDate: '2025-04-25T09:00:00Z',
    createdBy: 'exec@microsoft.com',
    createdAt: '2025-04-25T09:00:00Z',
    lastUpdatedAt: '2026-02-15T09:00:00Z',
    stateHistory: [
      {
        fromState: 'DRAFT',
        toState: 'SUBMITTED',
        changedBy: 'exec@microsoft.com',
        changedAt: '2025-04-25T09:00:00Z',
      },
      {
        fromState: 'SUBMITTED',
        toState: 'UNDER_REVIEW',
        changedBy: 'sarah.chen@microsoft.com',
        changedAt: '2025-05-15T10:00:00Z',
      },
      {
        fromState: 'UNDER_REVIEW',
        toState: 'CONFIRMED',
        changedBy: 'sarah.chen@microsoft.com',
        changedAt: '2026-02-15T09:00:00Z',
      },
    ],
  },
};

export const MOCK_SPACES = [
  {
    spaceId: 'sp-001',
    spaceName: 'Large Conference Room 450',
    floor: '4',
    roomCapacity: 200,
  },
  {
    spaceId: 'sp-002',
    spaceName: 'Innovation Lab',
    floor: '3',
    roomCapacity: 100,
  },
  {
    spaceId: 'sp-003',
    spaceName: 'Grand Ballroom',
    floor: '1',
    roomCapacity: 500,
    // Booked: every day unavailable.
    spaceAvailability: [{ dayStartTime: '', dayEndTime: '', timeZone: 'UTC', available: false }],
  },
  {
    spaceId: 'sp-004',
    spaceName: 'Meeting Room 210',
    floor: '2',
    roomCapacity: 30,
  },
  { spaceId: 'sp-005', spaceName: 'Board Room', floor: '5', roomCapacity: 20 },
];
